document.addEventListener("DOMContentLoaded", () => {
  // Callback function to execute when mutations are observed
  const bookEasyMutationCallback = function(mutationsList, observer) {
    for(let mutation of mutationsList) {
      if (mutation.type === 'childList') {
        const thankYou = document.querySelector('bookeasy-thank-you-v2');
        const currentPathArr = window.location.pathname.split("/")[window.location.pathname.split("/").length -1];
        if (thankYou) {
          console.log("BookEasy thank you showing");
          window.location.href = `/pages/thank-you-for-booking/${currentPathArr}`;
        }
      }
    }
  };

  // Create an observer instance linked to the callback function
  const bookEasyMutationObserver = new MutationObserver(bookEasyMutationCallback);
  const targetNode = document.querySelector('bookeasy-widget');

  // Start observing the target node for configured mutations
  bookEasyMutationObserver.observe(targetNode, { attributes: false, childList: true, subtree: true });
});